export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SmartBanner.json?hash=5965283777cf65a806706ca403189f00";